import React from "react";
import Head from "next/head";

// Components
import { Header } from "./Header";
import { Footer } from "./Footer";
import { MobileLogo } from "./MobileLogo";
import { Cart } from "./Cart";
import { Banner } from "./Banner";

export const Layout: React.FC = ({ children }) => {
  return (
    <>
      <Cart />
      <Banner type="desktop" />
      <Header />
      <main>
        <Banner type="mobile" />
        <MobileLogo />
        {children}
      </main>
      <Footer />
    </>
  );
};
